import { EntityTypeDTO } from '@/modules/common/types/dto/response/entity-type-dto';

export enum CustomAttributeTypeDTO {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  SINGLESELECT = 'SINGLESELECT',
  MULTISELECT = 'MULTISELECT',
}

export interface SelectOptionResponse {
  id: number;
  value: string;
}

export interface CustomAttributeResponse {
  id: number;
  name: string;
  type: CustomAttributeTypeDTO;
  selectOptions?: SelectOptionResponse[] | null;
  entityType: EntityTypeDTO;
}

export interface AttributeValueResponse {
  attribute: CustomAttributeResponse;
  value: boolean | string | number | null;
  selectedOptions?: SelectOptionResponse[];
}
